import { render, staticRenderFns } from "./Indexv2.vue?vue&type=template&id=facbc460&scoped=true&"
import script from "./Indexv2.vue?vue&type=script&lang=js&"
export * from "./Indexv2.vue?vue&type=script&lang=js&"
import style0 from "./Indexv2.vue?vue&type=style&index=0&id=facbc460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facbc460",
  null
  
)

export default component.exports